import { render, staticRenderFns } from "./OverflowMenu.vue?vue&type=template&id=4bcab3fe&"
import script from "./OverflowMenu.vue?vue&type=script&lang=ts&"
export * from "./OverflowMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports